export default __webpack_public_path__ + "static/media/new1.0427fc46.jpg";